var exports = {
  "kL": "x61f99309--55bae1--container",
  "wx": "x61f99309--55bae1--header",
  "W2": "x61f99309--55bae1--scroll",
  "Qs": "x61f99309--55bae1--content",
  "DD": "x61f99309--55bae1--title",
  "Dk": "x61f99309--55bae1--title__fixed",
};

module.exports = exports;
